if (!customElements.get('collection-read-more')) {
  class CollectionReadMore extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a[href^="#"]');
      if (!this.link) return;

      this.link.addEventListener('click', (event) => {
        const targetId = this.link.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();

        const header = document.querySelector('store-header[data-is-sticky="true"]');
        const offset = header ? header.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset - 24;

        window.scrollTo({ top, behavior: 'smooth' });
        target.focus({ preventScroll: true });
      });
    }
  }

  customElements.define('collection-read-more', CollectionReadMore);
}
